<h3 mat-dialog-title class="dialog-title">Hotel Type</h3>
<div mat-dialog-content>
  <mat-list>
    <mat-list-item *ngFor="let item of hotelType">
      <mat-checkbox [value]="item.name" color="primary">{{item.name}}</mat-checkbox>
    </mat-list-item>
  </mat-list>
</div>
